import { Component, inject } from '@angular/core';

import { I18nService } from '@core/i18n-legacy';
import { CompanyVerificationDialogComponent } from '@core/tellent-company-verification-smart-ui';
import { TellentWebComponent } from '@core/tellent-types';
import { RtPlatform } from '@core/user-interface-legacy';

import { DialogWrapComponent } from '../dialog/dialog-wrap.component';

@Component({
  selector: 'x-company-verification-dialog',
  template: ``,
  imports: [],
})
export class TellentCompanyVerificationDialogWrapComponent extends DialogWrapComponent<CompanyVerificationDialogComponent> {
  private readonly platform = inject(RtPlatform);
  private readonly i18n = inject(I18nService);

  public readonly component = CompanyVerificationDialogComponent;
  public readonly config = {
    mobileOptions: this.platform.IS_MOBILE
      ? {
          mobileDialog: true,
          mobileViewTitle: this.i18n.translate('tlc.company_verification.dialog.mobile_heading'),
        }
      : undefined,
  };
}

export type TellentCompanyVerificationDialogWebComponent = TellentWebComponent<
  TellentCompanyVerificationDialogWrapComponent,
  'afterClosed' | 'open'
>;
